export default __webpack_public_path__ + "static/media/s10.d1922062.jpg";